import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  padding: 30px 20px;
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  margin: 0 auto;
  background: #fff;
  @media (min-width: 992px) {
    padding: 30px 0px;
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-weight: 600 !important;
  padding-bottom: 16px;
`;

export const CoursesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  justify-content: center;
  @media (min-width: 576px) {
    grid-template-columns: 48% 48%;
    justify-content: space-between;
  }
  @media (min-width: 900px) {
    grid-template-columns: 31% 31% 31%;
    justify-content: space-between;
  }
  @media (min-width: 1600px) {
    grid-template-columns: ${(props) => (props.isRegionals ? '30% 30% 30%' : '23% 23% 23% 23%')};
  }
`;

export const NewCourseDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 15px auto;
  padding: ${(props) => (props.isFree || (props.isOffer && props.country === 'IN') ? '35px 0px 0px 0px' : '0px')};
  width: 100%;
  max-width: 320px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: ${(props) => (props.forSkeleton ? '0px 3px 9px var(--greyShadowColor)' : '0px 2px 12px var(--greyShadowColor)')};
  @media (min-width: 481px) {
    max-width: 380px;
  }
  @media (min-width: 576px) {
    max-width: unset;
  }
  @media (min-width: 768px) {
    margin: 20px 0px;
  }
`;

export const CourseDivInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 8px 10px 10px;
  @media (min-width: 992px) {
    padding: 10px 12px 12px;
  }
  @media (min-width: 992px) {
    padding: ${(props) => props.isRegionals && '10px 15px 15px'};
  }
`;

export const CourseDivSeparator = styled.hr`
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
`;

export const CourseImg = styled.img`
  width: 100%;
  height: auto;
`;

export const MaskContainer = styled.div`
  background: ${(props) => !props.showContent && 'linear-gradient(180deg,hsla(0,0%,100%,0.6) 0%,hsl(0, 0%, 100%) 62%,hsl(0, 0%, 100%) 100%)'};
  mask-size: contain;
  width: 100vw;
  height: ${(props) => (props.showContent ? '10vh' : props.sectionHeight)};
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
`;

export const SeeContent = styled.p`
  margin-bottom: 2px;
  cursor: pointer;
`;

export const SeeMoreIcon = styled.img`
  width: 25px;
  height: 25px;
  cursor: pointer;
  transform: rotate(${(props) => (props.showContent ? '180deg' : '0deg')});
`;

const offerShine = keyframes`
100% {  
  transform: translateX(480px) skewX(21deg);
}
`;

export const CourseCardTag = styled.div`
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  height: 35px;
  width: 100%;
  zindex: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--inputTxtColor);
  background-color: var(--goldenBgColor);
  overflow: hidden;
  font-size: 15px;
  font-family: var(--headingFont);
  font-weight: 500;
  ::before {
    content: '';
    position: absolute;
    width: 35px;
    height: 70px;
    left: -70px;
    background-color: #ffffff8c;
    filter: blur(15px);
    transform: skewX(21deg);
    animation: ${offerShine} 4.6s ease-in-out infinite;
  }
`;

// card pricing info tags
export const InfoTag = styled.span`
  display: inline-block;
  font-size: 13px;
  background: ${({ upcoming, isFree, newStatus, darkTheme }) =>
    upcoming ? 'var(--info)' : isFree && darkTheme ? 'var(--partnerPlusDark)' : isFree ? 'var(--partnerPlusColor)' : newStatus ? 'var(--orange)' : 'var(--primary)'};
  color: #fff;
  white-space: nowrap;
  padding: 3px 6px;
  margin-top: 8px;
  line-height: normal;
  border-radius: 4px;
`;

export const CourseDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  width: 24%;
  box-shadow: 0px 2px 20px 0px var(--blueShadowColor);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  @media (max-width: 900px) {
    width: 30%;
    margin: 10px;
  }
  @media (max-width: 600px) {
    width: 70%;
  }
`;
// promo wrapper
export const PromoWrapper = styled.div`
  padding: 4px;
  margin: 8px -10px 0px;
  background: var(--brandColor);
  @media (min-width: 992px) {
    margin: 8px -12px 0px;
  }
`;

// individual offer page styles
export const IndividualsTabContainer = styled.div`
  position: sticky;
  top: 55px;
  left: 0px;
  z-index: 5;
  display: flex;
  padding: 16px 16px 0px;
  margin: 0px -8px;
  overflow-x: auto;
  background-color: #fff;
  border-bottom: 1px solid var(--greyShadowColor);
  &::-webkit-scrollbar {
    display: block;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d2e3ff;
  }
  @media (min-width: 768px) {
    top: 60px;
    justify-content: center;
  }
`;

export const IndividualsTab = styled.button`
  height: 40px;
  min-width: 100px;
  padding: 5px 10px;
  margin-right: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: ${({ active }) => (active ? 'white' : 'var(--normalTxtColor)')} !important;
  background-color: ${({ active }) => (active ? 'var(--brandColor)' : 'white')};
  border: 1px solid ${({ active }) => (active ? 'var(--brandColor)' : 'var(--greyBorderColor)')};
  border-radius: 4px;
  transition: 0.2s;
  &:last-child {
    margin-right: unset;
  }
  &:hover {
    opacity: ${({ active }) => active && '0.9'};
    color: ${({ active }) => !active && 'var(--brandColor)'} !important;
  }
`;
